var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 24.8944C22.6967 24.8944 31.6001 25.6339 31.6001 32.0318C31.6001 38.7713 21.2257 39.1757 16.7756 39.2L15.1599 39.2C10.4151 39.1759 0.400146 38.7738 0.400146 32.0721C0.400146 25.3251 10.7746 24.9202 15.2247 24.8959L15.7593 24.8944C15.8426 24.8944 15.923 24.8944 16.0001 24.8944ZM16.0001 27.917C10.2899 27.917 3.48234 28.6364 3.48234 32.0721C3.48234 34.7965 7.69467 36.1789 16.0001 36.1789C24.3056 36.1789 28.518 34.7824 28.518 32.0318C28.518 29.3014 24.3056 27.917 16.0001 27.917ZM16.0001 0.79998C21.8173 0.79998 26.5516 5.44274 26.5516 11.1475C26.5638 13.896 25.4769 16.4915 23.496 18.4461C21.5193 20.4028 18.8789 21.4849 16.07 21.4949H16.0001C10.181 21.4949 5.44672 16.8522 5.44672 11.1475C5.44672 5.44274 10.181 0.79998 16.0001 0.79998ZM16.0001 3.82261C11.8803 3.82261 8.52891 7.10922 8.52891 11.1475C8.52891 15.1857 11.8803 18.4723 16.0001 18.4723H16.0638C18.0447 18.4642 19.9104 17.7005 21.3097 16.3162C22.7111 14.9358 23.4775 13.1001 23.4694 11.1535C23.4694 7.10922 20.118 3.82261 16.0001 3.82261Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.278cc91aff3e7c74ec5c6312ed14f7ba.svg";
export { ForwardRef as ReactComponent };